import request from '../utils/request';

export function getCustomerSupportTicket(data) {
  return request({
    url: '/customerSupport/ticket',
    data,
  });
}

export function submitCustomerSupport(data) {
  return request({
    url: '/customerSupport/message',
    data,
  });
}

export function getCustomerSupportStatus(data) {
  return request({
    url: '/customerSupport/status',
    data,
  });
}
